const routes = {
	// public routes
	home: '/',
	gdpr: '/gdpr',
	terms: '/terms',
	cookiesPolicy: '/cookies-policy',
	privacyPolicy: '/privacy-policy',
	refundPolicy: '/refund-policy',
	unsubscribe: '/unsubscribe',
	pricing: '/pricing',
	faqs: '/faqs',
	howTo: '/#how-to',
	contact: '/contact',
	sharedDocument: '/pdf/share/:id',
	editor: '/editor/:id',
	fastCheckout: '/editor/:id/payment',
	changePassword: '/change-password/:token',
	notFound: '/not-found',

	// protected routes
	checkout: '/app/checkout',
	newDocument: '/new-document',
	myDocuments: '/app/my-documents',
	folder: '/app/my-documents/folder/:id',
	users: '/app/users',
	billing: '/app/billing',
	settings: '/app/settings',
	myAccount: '/app/my-account'
};

export default routes;
